import { render, staticRenderFns } from "./BaseCheckboxSelect.vue?vue&type=template&id=67dab90b&scoped=true"
import script from "./BaseCheckboxSelect.vue?vue&type=script&lang=js"
export * from "./BaseCheckboxSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseCheckboxSelect.vue?vue&type=style&index=0&id=67dab90b&prod&lang=scss&scoped=true"
import style1 from "./BaseCheckboxSelect.vue?vue&type=style&index=1&id=67dab90b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dab90b",
  null
  
)

export default component.exports